module.exports = __webpack_public_path__ + "static/img/1063de37a72df9a65ee93f348722db22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advant_disable_02.png
// module id = hoBA
// module chunks = 1